const allProjects = [
  {
    title: 'Meal Map',
    img: require('../img/Project1.webp'),
    description:
      'Meal Map is a website to search food recipes around the world, this website uses the edamam API.',
    websiteUrl: 'https://blog.itsseon.xyz',
    githubUrl: 'https://blog.itsseon.xyz',
    techStack: ['Javascript', 'SASS', 'RESTful API'],
  },
  {
    title: 'Simpel Store',
    img: require('../img/Project17.webp'),
    description:
      'Simple Store is a full-stack website, allowing users to add items, earn tokens, and redeem tokens.',
    websiteUrl: 'https://blog.itsseon.xyz',
    githubUrl: 'https://blog.itsseon.xyz',
    techStack: ['Next.js', 'Express', 'Firebase'],
  },
  {
    title: 'BarKit (Team Project)',
    img: require('../img/Project16.webp'),
    description:
      'Barkit is a rental application with a primary feature of clickbait item detection',
    websiteUrl: '',
    githubUrl: 'https://blog.itsseon.xyz',
    techStack: ['Android', 'Express', 'React', 'GCP'],
  },
  {
    title: 'Animal Aid',
    img: require('../img/Project13.webp'),
    description:
      'Animal Aid is an organization that saves animals from suffering, rehabilitates and releases them back into the wild (Front-End).',
    websiteUrl: 'https://blog.itsseon.xyz',
    githubUrl: 'https://blog.itsseon.xyz',
    techStack: ['Javascript', 'HTML5', 'CSS3'],
  },
  {
    title: 'E-Bookpolis',
    img: require('../img/Project3.webp'),
    description:
      'E-bookpolis is a website for selling and ordering book products (Front-End).',
    websiteUrl: 'https://blog.itsseon.xyz',
    githubUrl: 'https://blog.itsseon.xyz',
    techStack: ['Javascript', 'SwiperJS'],
  },

  {
    title: 'Personal Notes',
    img: require('../img/Project15.webp'),
    description: 'A web app to save your notes with CRUD functionalities.',
    websiteUrl: 'https://blog.itsseon.xyz',
    githubUrl: 'https://blog.itsseon.xyz',
    techStack: ['ReactJS', 'Redux'],
  },
  {
    title: 'Dapper Barber',
    img: require('../img/Project6.webp'),
    description:
      'Dapper barber is a website for finding the best barbers in a city.',
    maintenence: true,
    websiteUrl: 'https://blog.itsseon.xyz',
    githubUrl: 'https://blog.itsseon.xyz',
    techStack: ['Bootstrap 5', 'PHP'],
  },

  {
    title: 'Food Ordering MU',
    img: require('../img/Project4.webp'),
    description:
      'Food ordering application at Marugame Udon restaurant, this application consists of users/buyers and there is a special application for admin/waitresses',
    websiteUrl: '',
    githubUrl:
      'https://blog.itsseon.xyz',
    techStack: ['Java', 'Android'],
  },
  {
    title: 'Weather Search',
    img: require('../img/Project7.webp'),
    description:
      'Is a website to find the current weather around the world, this website uses the OpenWeather API.',
    websiteUrl: 'https://blog.itsseon.xyz',
    githubUrl: 'https://blog.itsseon.xyz',
    techStack: ['ReactJS', 'SCSS', 'API'],
  },
  {
    title: 'Hoax News Detection (Team Project)',
    img: require('../img/Project14.webp'),
    description:
      'The project we created is a hoax news detection website, by simply entering the url of the news website you want to know the truth of.',
    websiteUrl: '',
    githubUrl: 'https://blog.itsseon.xyz',
    techStack: ['Python', 'Flask', 'Bootstrap5', 'ML'],
  },
  // {
  //   title: 'Marugame Landing Page',
  //   img: require('../img/Project11.webp'),
  //   description: 'Website to promote food menus at marugame udon restaurants',
  //   websiteUrl: 'https://muhthoriqas.github.io/Marugame-Udon-LandingPage/',
  //   githubUrl: 'https://github.com/Muhthoriqas/Marugame-Udon-LandingPage',
  //   techStack: ['Bootstrap 5'],
  // },
  // {
  //   title: 'Fish Weight Prediction',
  //   img: require('../img/Project12.webp'),
  //   description:
  //     'This is a project to detect fish weight using 2 machine learning models, namely linear regression and polynomial regression',
  //   websiteUrl: '',
  //   githubUrl:
  //     'https://github.com/Muhthoriqas/Fish_Weight_Prediction_Linear_And_Polynomial_Regression',
  //   techStack: ['Python', 'Machine Learning'],
  // },

  {
    title: 'Ordering Foods',
    img: require('../img/Project5.webp'),
    description:
      'Website for ordering food and drinks, on this website there is a special menu for the admin who can change the menu food and users who can only view and order food',
    websiteUrl: '',
    githubUrl: 'https://blog.itsseon.xyz',
    techStack: ['Python', 'Django'],
  },
];

export default allProjects;
